export default "__VITE_ASSET__C47up0vm__"